import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import withProps from '~lib/common/hoc/withProps';
import renameProps from '~lib/common/hoc/renameProps';

import promptQueries from '~lib/common/queries/Prompt';
import PromptDialog from './PromptDialog.vue';

const enhance = compose(
  withProps({
    promptType: 'patient',
  }),
  dataView({ queries: promptQueries }, { promptType: 'patient' }),
  renameProps({ data: 'prompts' }),
);

export default enhance(PromptDialog);
